import React from 'react';
import { isPricingEnabled } from '@/libs/pricingEnabled';
import styles from '../HomepageSections.module.scss';
import { AccreditationSection } from './Accreditation';
import { ClosingCta } from './ClosingCta';
import { ContactSection } from './Contact';
import { CoverageSection } from './Coverage';
import { CustomerProof } from './CustomerProof';
import { ExpertiseSection } from './Expertise';
import { FaqSection } from './Faq';
import { InvoiceJourney } from './InvoiceJourney';
import { PlatformSection } from './Platform';
import { PricingSection } from './Pricing';
import { ScaleSection } from './Scale';

export const HomepageSections = () => (
  <div className={styles.homepageSections}>
    <CustomerProof />
    <InvoiceJourney />
    <ExpertiseSection />
    <PlatformSection />
    <ScaleSection />
    <CoverageSection />
    {isPricingEnabled() && <PricingSection />}
    <AccreditationSection />
    <ContactSection />
    <FaqSection />
    <ClosingCta />
  </div>
);
